import state from './rolesets.state';
import getters from './rolesets.getters';
import mutations from './rolesets.mutations';
import actions from './rolesets.actions';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
